<template>
  <div
    :class="{ focusInSelect: focusInSelect }"
    class="rt-address"
  >
    <div class="address-select-all">
      <div class="address-select">
        <el-select
          v-model="address.province[alias.id]"
          :disabled="computedDisabled"
          :placeholder="
            computedDisabled
              ? computedEmptyPlaceholder
              : $tx('省', 'xpc.address.province')
          "
          :filterable="provinceFilterable"
          :filter-method="filterMethod"
          @focus="focus1"
          @blur="blur1"
          @change="provinceChange"
          @keydown.native="handleProvinceKeydown"
        >
          <el-option
            v-for="(item, index) in provinces"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          >
            <div v-html="highlightKey(item[alias.name])"></div>
          </el-option>
        </el-select>
        <rt-icon
          v-if="!computedDisabled"
          :color="SCSS_VARIABLES.COLOR_INFO"
          name="rt-base-dropdown"
        />
      </div>
      <div class="address-select">
        <el-select
          v-model="address.city[alias.id]"
          :disabled="computedDisabled"
          :placeholder="
            computedDisabled
              ? computedEmptyPlaceholder
              : $tx('市', 'xpc.address.city')
          "
          :filterable="cityFilterable"
          :filter-method="filterMethod"
          @focus="focus2"
          @blur="blur2"
          @change="cityChange"
          @keydown.native="handleCityKeydown"
        >
          <el-option
            v-for="(item, index) in cities"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          >
            <div v-html="highlightKey(item[alias.name])"></div>
          </el-option>
        </el-select>
        <rt-icon
          v-if="!computedDisabled"
          :color="SCSS_VARIABLES.COLOR_INFO"
          name="rt-base-dropdown"
        />
      </div>
      <div class="address-select">
        <el-select
          v-model="address.country[alias.id]"
          :disabled="computedDisabled"
          :placeholder="
            computedDisabled
              ? computedEmptyPlaceholder
              : $tx('县/区', 'xpc.address.county')
          "
          :filterable="countryFilterable"
          :filter-method="filterMethod"
          @focus="focus3"
          @blur="blur3"
          @change="countryChange"
        >
          <el-option
            v-for="(item, index) in countries"
            :key="index"
            :label="item[alias.name]"
            :value="item[alias.id]"
          >
            <div v-html="highlightKey(item[alias.name])"></div>
          </el-option>
        </el-select>
        <rt-icon
          v-if="!computedDisabled"
          :color="SCSS_VARIABLES.COLOR_INFO"
          name="rt-base-dropdown"
        />
      </div>
      <div
        :class="{ focusInSelect: focusInSelect }"
        class="rt-input-shadow"
      />
    </div>
    <div class="address-input">
      <rt-input
        v-model="address.address"
        :disabled="computedDisabled"
        :placeholder="computedInputPlaceholder"
        :clearable="computedClearable"
        :clear-icon-name="clearIconName"
        :clear-icon-right="clearIconRight"
        @focus="focusInput"
        @blur="blurInput"
        @change="addressChange"
        @click="inputChange"
      />
      <div
        :class="{ focusInInput: focusInInput }"
        class="rt-input-shadow"
      />
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtInput from '../form/rtInput';
import config from '../../config';
import ElSelect from 'vue-xpc/src/element-ui/packages/select/src/select.vue';
import addressData from '../../libs/address/address';
import Placeholder from '../form/placeholder.js';

export default {
  name: 'RtAddress',
  components: {
    RtIcon,
    RtInput,
    ElSelect
  },
  mixins: [Placeholder],

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否可以清空选项
    clearable: {
      type: Boolean,
      default: undefined
    },
    // 自定义清空按钮图标
    clearIconName: {
      type: String,
      default: undefined
    },
    // 自定义清空按钮位置
    clearIconRight: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      selected1: false,
      selected2: false,
      selected3: false,
      focusInInput: false,
      address: {
        province: {},
        city: {},
        country: {}
      },
      provinces: [],
      cities: [],
      countries: [],
      config: {},
      alias: {},
      isFirst: true,
      provinceFilterable: false,
      cityFilterable: false,
      countryFilterable: false,
      keyWord: ''
    };
  },
  inject: {
    elForm: {
      default: ''
    }
  },
  computed: {
    computedClearable () {
      return this.clearable === undefined
        ? this.elForm &&
            this.elForm.$attrs &&
            this.elForm.$attrs['all-clearable']
        : this.clearable;
    },
    computedIconName () {
      return this.clearIconName || config.get('clearicon.clearIconName');
    },
    computedClearIconStyle () {
      let style = {};
      if (this.computedClearable) {
        style['marginRight'] =
          this.clearIconRight || config.get('clearicon.clearIconRight') + 'px';
      }
      return style;
    },
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    },
    focusInSelect () {
      return (
        this.selected1 || this.selected2 || this.selected3 || this.focusInInput
      );
    }
  },
  watch: {
    value (newValue) {
      this.address = JSON.parse(JSON.stringify(newValue));
      if (this.isFirst) {
        let { alias } = this;
        // 初始化城市，若未传省份ID则根据名称去匹配
        if (this.address.province[alias.id]) {
          this.getCities();
        } else if (this.address.province[alias.name]) {
          const id = this.provinces.find(
            item => item[alias.name] === this.address.province[alias.name]
          )[alias.id];
          this.address.province[alias.id] = id;
          this.getCities();
        }
        // 初始化区县，若未传城市ID则根据名称去匹配
        if (this.address.city[alias.id]) {
          this.getCountries();
        } else if (this.address.city[alias.name]) {
          const id = this.cities.find(
            item => item[alias.name] === this.address.city[alias.name]
          )[alias.id];
          this.address.city[alias.id] = id;
          this.getCountries();
        }
        // 若仅传区县名称，未传ID的，完善区县数据
        if (!this.address.country[alias.id] && this.address.country[alias.name]) {
          const id = this.countries.find(
            item => item[alias.name] === this.address.country[alias.name]
          )[alias.id];
          this.address.country[alias.id] = id;
        }
        this.addressChange()
      }
      this.isFirst = false;
    }
  },
  mounted () {
    this.getProvinces();
  },
  methods: {
    handleProvinceKeydown (event) {
      const keyCode = event.keyCode;

      // Tab
      if (keyCode === 9) {
        if (this.address.province[this.alias.id]) {
          this.cityFilterable = true;
        }
      }
    },

    handleCityKeydown (event) {
      const keyCode = event.keyCode;

      // Tab
      if (keyCode === 9) {
        if (this.address.city[this.alias.id]) {
          this.countryFilterable = true;
        }
      }
    },

    inputChange () {
      this.address.city = {};
      this.address.country = {};
      this.address.province = {};
      this.address.address = '';
    },
    async getProvinces () {
      this.config = config.get();
      this.alias = this.config.address.alias;
      let provinceUrl = this.config.address.provinceUrl;
      this.provinces = provinceUrl
        ? await rt.get(provinceUrl)
        : addressData.filter(item => {
          return item.ParentId === '';
        });
    },
    async getCities () {
      let citiesUrl = this.config.address.cityUrl;
      let _config = {
        id: this.address.province[this.alias.id],
        params: {
          id: this.address.province[this.alias.id]
        }
      };
      const cityData = citiesUrl
        ? await rt.get(citiesUrl, _config)
        : addressData;
      this.cities = cityData.filter(item => {
        return item.ParentId === this.address.province[this.alias.id];
      });
    },
    async getCountries () {
      let countriesUrl = this.config.address.countyUrl;
      let _config = {
        id: this.address.city[this.alias.id],
        params: {
          id: this.address.city[this.alias.id]
        }
      };
      const countriesData = countriesUrl
        ? await rt.get(countriesUrl, _config)
        : addressData;
      this.countries = countriesData.filter(item => {
        return item.ParentId === this.address.city[this.alias.id];
      });
    },
    provinceChange () {
      this.address.city = {};
      this.address.country = {};
      this.address.address = '';
      if (this.address.province) {
        this.provinces.map(item => {
          if (item[this.alias.id] === this.address.province[this.alias.id]) {
            this.address.province[this.alias.name] = item[this.alias.name];
          }
        });
        this.getCities();
        this.change();
      }
    },
    cityChange () {
      this.address.country = {};
      this.address.address = '';
      if (this.address.city) {
        this.cities.map(item => {
          if (item[this.alias.id] === this.address.city[this.alias.id]) {
            this.address.city[this.alias.name] = item[this.alias.name];
          }
        });
        this.getCountries();
        this.change();
      }
    },
    countryChange () {
      this.address.address = '';
      if (this.address.country) {
        this.countries.map(item => {
          if (item[this.alias.id] === this.address.country[this.alias.id]) {
            this.address.country[this.alias.name] = item[this.alias.name];
          }
        });
        this.change();
      }
    },
    addressChange () {
      this.change();
    },
    change () {
      this.$emit('input', this.address);
    },
    focus1 () {
      this.selected1 = true;
      this.provinceFilterable = true;
    },
    blur1 () {
      this.keyWord = '';
      this.selected1 = false;
      this.provinceFilterable = false;
    },
    focus2 () {
      this.selected2 = true;
    },
    blur2 () {
      this.keyWord = '';
      this.selected2 = false;
      this.cityFilterable = false;
    },
    focus3 () {
      this.selected3 = true;
    },
    blur3 () {
      this.keyWord = '';
      this.selected3 = false;
      this.countryFilterable = false;
    },
    focusInput () {
      this.focusInInput = true;
    },
    blurInput () {
      this.focusInInput = false;
    },
    highlightKey (text) {
      const reg = new RegExp(this.keyWord, 'g');
      return text
        ? text.replace(
          reg,
          `<span style='color:#ff9500;'>${this.keyWord}</span>`
        )
        : '';
    },
    filterMethod (key) {
      this.keyWord = key;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAddress.vue?034892e0